import { render, staticRenderFns } from "./AdminImg.vue?vue&type=template&id=30579be0&scoped=true&"
import script from "./AdminImg.vue?vue&type=script&lang=js&"
export * from "./AdminImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30579be0",
  null
  
)

export default component.exports